/**
 * @file: 商品陈列位打不陈列标签
 * @author: xiaolong.huang@dmall.com
 */

import * as UIToolkit from '../../UIToolkit';

function add(cubeIds: CubeId[]): void {
    UIToolkit.tips('接口开发中...');
}

export default {
    add
};
